import React from "react";
import "../../styles/components/AppsShowcase.css";

import app1 from "../../img/apps/app-1.webp";
import app2 from "../../img/apps/app-2.webp";
import app3 from "../../img/apps/app-3.webp";
import app4 from "../../img/apps/app-4.jpg";
import app5 from "../../img/apps/app-5.webp";
import app6 from "../../img/apps/app-6.jpg";
import app7 from "../../img/apps/app-7.webp";
import app8 from "../../img/apps/app-8.webp";
import app9 from "../../img/apps/app-9.webp";
import app10 from "../../img/apps/app-10.png";
import app11 from "../../img/apps/app-11.webp";
import app12 from "../../img/apps/app-12.jpg";
import app13 from "../../img/apps/app-0.webp";

import app14 from "../../img/apps/app-13.png";
import app15 from "../../img/apps/app-14.webp";
import app16 from "../../img/apps/app-15.webp";
import app17 from "../../img/apps/app-16.webp";
import app18 from "../../img/apps/app-17.webp";
import app19 from "../../img/apps/app-18.webp";
import app20 from "../../img/apps/app-19.webp";
import app21 from "../../img/apps/app-20.webp";
import app22 from "../../img/apps/app-21.webp";
import app23 from "../../img/apps/app-22.png";
import app24 from "../../img/apps/app-23.webp";
import app25 from "../../img/apps/app-24.png";
import app26 from "../../img/apps/app-25.webp";

import app27 from "../../img/apps/app-26.png";
import app28 from "../../img/apps/app-27.png";
import app29 from "../../img/apps/app-28.webp";
import app30 from "../../img/apps/app-29.webp";
import app31 from "../../img/apps/app-30.png";
import app32 from "../../img/apps/app-31.png";
import app33 from "../../img/apps/app-32.png";
import app34 from "../../img/apps/app-33.png";
import app35 from "../../img/apps/app-0.webp";
import app36 from "../../img/apps/app-0.webp";
import app37 from "../../img/apps/app-0.webp";
import app38 from "../../img/apps/app-0.webp";
import app39 from "../../img/apps/app-0.webp";

const appRows = [
  [
    app1, app2, app3, app4, app5, app6, app7, app8, app9, app10, app11, app12, app13,
  ],
  [
    app14, app15, app16, app17, app18, app19, app20, app21, app22, app23, app24,
  ],
  [
    app25, app26, app27, app28, app29, app30, app31, app32, app33, app34, app35,
  ],
];

export default function AppsShowcase() {
  return (
    <section className="apps">
      <div className="apps__box">
        <h2 className="apps__title">Apps</h2>

        <div className="apps__rows">
          {appRows.map((row, rowIndex) => (
            <div
              className={`apps__marquee ${rowIndex === 1 ? "apps__marquee--reverse" : ""
                }`}
              key={rowIndex}
            >
              <div className="apps__track">
                {[...row, ...row].map((icon, iconIndex) => (
                  <div
                    className="apps__item"
                    key={`${rowIndex}-${iconIndex}`}
                  >
                    <img src={icon} alt="" />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
